export const verificationReducer = (state, action) => {
  switch (action.type) {
    case "SET_VERIFY":
      return { ...action.verification };
    default:
      return state;
  }
};
